var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 361,
    viewBox: "0 0 256 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_15130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.844 360.088L23.6617 331.166L0.44519 70.7656H255.555L232.314 331.125L127.844 360.088Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.417 314.546L232.278 92.0566H128V337.95L212.417 314.546Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6686 188.637L56.531 220.573H128V188.637H53.6686Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.917 123.994L50.8202 155.932H128V123.994H47.917Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 271.579L127.86 271.617L92.2915 262.012L90.0178 236.541H57.958L62.4324 286.687L127.853 304.848L128 304.807V271.579Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4835 0H99.1648V16.1758H76.6593V32.3517H99.1648V48.5275H60.4835V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.901 0H145.582V14.0659H123.077V16.8791H145.582V49.2308H106.901V34.4615H129.407V31.6484H106.901V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.319 0H192V14.0659H169.495V16.8791H192V49.2308H153.319V34.4615H175.824V31.6484H153.319V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.127 188.636L207.892 123.994H127.89V155.932H172.892L169.986 188.636H127.89V220.572H167.216L163.509 261.992L127.89 271.606V304.833L193.362 286.687L193.843 281.291L201.347 197.212L202.127 188.636Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_15130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 361,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.f839a58e48a79334a14b295fbc3ae561.svg";
export { ForwardRef as ReactComponent };